import { defineStore } from 'pinia'
import { reactive } from 'vue'
import { CART_CHANGED_MODAL, ERROR_MODAL, LOGIN_MODAL, REORDER_MODAL } from "@/types/Modals"

export const useModalsStore = defineStore('modals', () => {
  const modals = reactive({
    [CART_CHANGED_MODAL]: {
      isOpen: false,
      data: {},
    },
    [ERROR_MODAL]: {
      isOpen: false,
      data: {},
    },
    [LOGIN_MODAL]: {
      isOpen: false,
      data: {},
    },
    [REORDER_MODAL]: {
      isOpen: false,
      data: {},
    },
  })

  const isOpen = (modal: string): boolean => modals[modal].isOpen
  const getData = (modal: string): {} => modals[modal].data

  const toggle = (modal: string, isOpen: boolean, data: any | {} = {}) => {
    modals[modal].isOpen = isOpen
    modals[modal].data = data
  }

  const setData = (modal: string, data: any) => {
    modals[modal].data = data
  }

  return {
    isOpen,
    getData,
    toggle,
    setData,
  }
})